
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form,Input, Layout, Empty, Space, Card, Carousel,Button,Select,Modal  } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';
import { IconSearch } from '@arco-design/web-react/icon';
import * as news_config from '../common/news_config'
const Option = Select.Option;
const FormItem = Form.Item;
const InputSearch = Input.Search;

export default class App extends MyComp{
  constructor(props) {
    super(props);

    this.ref_form = React.createRef();
    let yearList = [2020, 2021, 2022, 2023, 2024]
    yearList.sort((a,b)=>{return b-a})

    this.allList = news_config.getNewsList()
    this.state = {
      ...this.state,
      yearList: yearList,
      newsList: [],

      formInfo: {
        year: undefined,
        searchVal: '',
      },
      language: this.props.language || 'ch'
    }
  }
  componentDidMount(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize()
    this.getData()
    
  }
  componentWillReceiveProps(nextProps){
    console.log(nextProps)
    this.allList = news_config.getNewsList(nextProps.language)
    this.setState({
      language: nextProps.language
    })
  }
  getData(){
    let {formInfo} = this.state
    let reqData = {
      op: 'getNews',
      year: formInfo.year,
      searchVal: formInfo.searchVal
    }
    let successFunc = (rsp)=>{
      console.log(rsp)
      this.initNews()
    }
    let failFunc = (rsp)=>{
      console.log(rsp)
      this.initNews()
    }
    utils.SendMsg(reqData, successFunc, failFunc)
  }
  initNews(data){
    let {formInfo} = this.state
    let newsList = []
    let allList = this.allList
    allList.map(a=>{

      let con1 = formInfo.year == undefined || formInfo.year == a.year.toString()
      let con2 = formInfo.searchVal == '' || a.title.includes(formInfo.searchVal)
      console.log(con1, con2, formInfo.year, a.year.toString())
      if(con1 && con2){
        newsList.push(a)
      }
      
    })
    newsList.sort((a,b)=>{
      if(a.year == b.year){
        if(a.month == b.month){
          return b.day - a.day
        }
        return b.month - a.month
      }
      return b.year - a.year
    })
    this.setState({
      newsList: newsList
    })
  }
  onSearchChange(v, vs){
    let {formInfo, yearList} = this.state
    let shouldGetData = false
    for(let k in v){
      let a = v[k]
      formInfo[k] = a
      if(k == 'year'){
        shouldGetData = true
      }
    }

    this.setState({
      formInfo: formInfo,
    }, ()=>{
      if(shouldGetData){
        this.getData()
      }
    })
  }

  getSearchNote(){
    let {formInfo, yearList} = this.state

    return (
      <div style={{display: 'flex', justifyContent: 'left', width: '84.5vw'}}>
        <Form id='searchForm' layout='inline'
          ref={(ref) => (this.ref_form = ref)}
          onSubmit={(values)=>{
            // console.log(values)
          }}
          onValuesChange={(v, vs) => {
            this.onSearchChange(v, vs)
          }}
          style={{marginTop:10}}
          initialValues={formInfo}
        >
          <Space wrap size={[10, 0]} align='start'>
            <FormItem label='' field='year' key='year'>
              <Select
                placeholder='请选择年份'
                style={{ width: 150 }}
                // dropdownMenuStyle={{minHeight: '80vh'}}
                // defaultValue={[]}
                // showSearch={{ retainInputValue: true }}
                allowClear
                triggerProps={{
                  autoAlignPopupWidth: false,
                  autoAlignPopupMinWidth: true,
                  position: 'bl',
                }}
              >
                {yearList.map((option) => (
                  <Option key={option} value={option}>
                    {option}年
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem label='' field='searchVal'>
                <InputSearch 
                  allowClear
                  prefix={<IconSearch />}
                  placeholder='搜索关键词'
                  style={{ }}
                  searchButton='搜索'
                  onClear={(val)=>{
                    this.getData()
                  }}
                  onSearch={(val)=>{
                    this.getData()
                  }}
                />
            </FormItem>
          </Space>
      </Form>
      </div>
    )
  }
  getCard(dat, num){
    if(!dat){
      return
    }
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let rate = winWidth/2027
    if(num == 2){
      rate = winWidth/2027*1.58
    }
    return (
      <Space direction='vertical' align='start' onClick={()=>{
        utils.openUrl(dat.url)
      }}
      style={{ cursor: 'pointer' }}

      >
        <ScaledImage src={dat.icon} rate={rate}></ScaledImage>
        <div style={{left: '0vw', top: '1vw', width:rate*460,height:rate*220, position: 'relative'}}>
          <div style={{position: 'absolute'}}>
            {/* <ScaledImage src={dat.icontext} rate={rate}></ScaledImage> */}
          </div>
          {/* #444A4F */}

          <div style={{color: '#444A4F'}}>
            <div style={{backgroundColor: 'rgba(0, 0, 0, 0.5)', color: '#F6F1F1',width:rate*521,height:rate*40,left:'0vw', top:rate*-65 , position:'absolute',}}>
              <div style={{color: '#F6F1F1',width:rate*400,height:rate*40,left:'3vw', top:rate*4, fontSize: 20*rate,position:'absolute',textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow:'hidden', lineHeight: 1.5}}>
                {dat.title}
              </div>
            </div>
            <div style={{position:'absolute',left: 0*rate, top: 25*rate, fontSize: 70*rate, fontFamily: 'Century Gothic Regular'}}>{dat.dayStr}</div>
            <div style={{position:'absolute',left: 65*rate, top: 50*rate, fontSize: 70*rate, fontFamily: 'Century Gothic Regular'}}>·</div>
            <div style={{position:'absolute',left: 105*rate, top: 12*rate, fontSize: 24*rate, fontFamily: 'Penny Lane'}}>{dat.monthStr}</div>
            <div style={{position:'absolute',left: 107*rate, top: 40*rate, fontSize: 24*rate, fontFamily: 'Century Gothic Regular'}}>{dat.year}</div>
            <div style={{position:'absolute',left: 0*rate, top: 105*rate, fontSize: 24*rate, lineHeight: 1.5, textAlign:'left'}}>{dat.title}</div>
          </div>
        </div>
      </Space>
    )
  }
  getNewsLine(idx, rate, num){
    let {newsList} = this.state
    let imin = idx*num
    if(num == 2){
      return (
        // <Space key={"ddd"+idx} size={75*rate} style={{width: '84.5vw', paddingBottom: '4vw'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', width: '84.5vw',paddingBottom: '4vw'}}>
          {this.getCard(newsList[imin], num)}
          {this.getCard(newsList[imin+1], num)}
          </div>
        // </Space>
      )
    }
    return (
      // <Space key={"ddd"+idx} size={75*rate} style={{width: '84.5vw', paddingBottom: '4vw'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', width: '84.5vw',paddingBottom: '4vw'}}>
        {this.getCard(newsList[imin], num)}
        {this.getCard(newsList[imin+1], num)}
        {this.getCard(newsList[imin+2], num)}
        </div>
      // </Space>
    )
  }
  getNewsPanel(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let rate = winWidth/2027
    let num = 3
    if(rate < 0.5){
      num = 2
    }
    let {newsList} = this.state
    let count = Math.ceil(newsList.length/num)
    let xList = Array.from({ length: count })

    if(count == 0){
      let url = `../imgs/img_tip1_1.png`
      return <Empty imgSrc={url} description='精彩继续' style={{paddingTop: '10vw', paddingBottom: '10vw'}}/>;
    }
    return (
      <Space direction='vertical' align='start' style={{paddingTop: '2vw'}}>
        {
          xList.map((v,i)=>{
            return this.getNewsLine(i, rate, num)
          })
        }
      </Space>
    )
  }
  getBody(){
    return (
      <Space size={0} direction='vertical' style={{  paddingTop: '4vw', paddingBottom: '4vw',
      // ,marginLeft:'3vw', marginTop: '6vw', marginBottom: '6vw'
      
      }}>
        {this.getSearchNote()}
        {this.getNewsPanel()}
      </Space>
    )
  }
  render() {
    return (
      <div>
        {this.getBody()}
      </div>
    );
  }
}

